// src/utils/currency.ts

// Read location + currency info from localStorage
export function getStoredLocation() {
  const data = localStorage.getItem("userLocation");
  if (!data) return null;

  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
}

// Main API call
export async function convertLocalCurrency(
  country: string,
  price: number,
  baseCurrency: string = "USD"
) {
  try {
    const response = await fetch(
      "https://backend.stagobox.com/api/convert-local-currency/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          base_currency: baseCurrency,
          country: country,
          price: price,
        }),
      }
    );

    if (!response.ok) return null;
    const jsonData = await response.json()
    // console.log(await response.json());
    return jsonData; // { converted_price, symbol, currency_code }
  } catch (error) {
    console.error("Currency conversion error:", error);
    return null;
  }
}

/**
 * AUTO MODE:
 * Converts price using saved country *and* saved currency from localStorage.
 *
 * - If currency exists in localStorage → use that currency info directly
 * - Otherwise → call the API and update the stored data
 *
 */
export async function convertPrice(price: number, baseCurrency = "USD", options?: { geoTimeoutMs?: number; forceRefresh?: boolean }) {
  const stored = getStoredLocation();

  if (!stored) {
    console.warn("No stored location found.");
    return null;
  }

  const country = stored.country;
  const storedCurrency = stored.currency; // { currency_code, symbol, converted_price, rate }

  // If currency info exists → use the rate directly
  if (storedCurrency && storedCurrency.rate) {
    return {
      converted_price: storedCurrency.rate * price,
      currency_code: storedCurrency.currency_code,
      symbol: storedCurrency.symbol,
      source: "localStorage",
    };
  }

  // Otherwise → call the API and update localStorage
  const result = await convertLocalCurrency(country, price, baseCurrency);

  if (result) {
    // Save updated currency info to localStorage
    const updated = {
      ...stored,
      currency: {
        ...result,
        rate: result.converted_price / price, // store rate for future quick conversion
      },
    };

    localStorage.setItem("userLocation", JSON.stringify(updated));
  }

  return result;
}
